import { useState, useMemo } from "react";
import type { SelectOption } from "../types/types";

export const useSingleSelectSearch = (options: SelectOption[], filterOptionsLocally: boolean = true) => {
	const [searchTerm, setSearchTerm] = useState("");

	// Ensure options is always an array and filter invalid options
	const safeOptions = useMemo(() => {
		if (!Array.isArray(options)) return [];
		return options.filter(opt => {
			if (!opt || typeof opt !== 'object' || opt === null) return false;
			if (!('label' in opt) || !opt.label) return false;
			return typeof opt.label === 'string';
		});
	}, [options]);

	const filteredOptions = useMemo(() => {
		if (!filterOptionsLocally) return safeOptions;
		if (!searchTerm) return safeOptions;
		return safeOptions.filter(
			option => {
				if (!option || !option.label || typeof option.label !== 'string') return false;
				return option.label.toLowerCase().includes(searchTerm.toLowerCase()) &&
					!option.isPlaceholder;
			}
		);
	}, [safeOptions, searchTerm, filterOptionsLocally]);

	const resetSearch = () => {
		setSearchTerm("");
	};

	return {
		searchTerm,
		setSearchTerm,
		filteredOptions,
		resetSearch,
	};
};
